<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1"></a>
<p class="title1">Helping Stop Hitler’s Luftwaffe</p>
<a id="VPS-2"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Half_Title.vue?1d46fd08